import { Divider, Modal, Button, Input, Select } from 'antd';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useAppSelector, useAppDispatch } from '../../methods/redux/hooks';
import {
	toggleDisableWithdrawal,
	toggleDisableDeposit,
	updateContractAddress,
} from '../../methods/redux/reducers/currency';

const SingleContractAddressStyle = styled.section`
	& .address {
		display: grid;
		margin-bottom: 30px;
	}

	& .action-buttons {
		display: grid;
		grid-template-columns: 1fr;
		grid-gap: 20px;

		@media (min-width: 768px) {
			grid-template-columns: 1fr 1fr;
		}
	}

	& .grid-3-buttons {
		display: grid;
		grid-template-columns: 1fr;
		grid-gap: 8px;

		@media (min-width: 768px) {
			grid-template-columns: 1fr 1fr 1fr;
		}
	}
`;

interface ISingleContractAddress {
	blockchainIcon: any;
	blockchainAbbreviation: any;
	blockchainId: any;
	currencyId: any;
	contractAddress: any;
	contractAddressId: any;
	decimals: any;
	minimumWithdrawalAmount: any;
	minDepositAmount: any;
	minWithdrawalAmountInUsd: any;
	minDepositAmountInUsd: any;
}

const SingleContractAddress = ({
	blockchainId,
	blockchainAbbreviation,
	blockchainIcon,
	currencyId,
	contractAddress,
	contractAddressId,
	decimals,
	minimumWithdrawalAmount,
	minDepositAmount,
	minWithdrawalAmountInUsd,
	minDepositAmountInUsd,
}: ISingleContractAddress) => {
	const dispatch = useAppDispatch();
	const { contracts, disabledCurrencyWithdrawal, disabledCurrencyDeposit } =
		useAppSelector((store) => store.currencies);

	console.info('contractAddressId', contractAddressId);

	const [state, setState] = useState({
		blockchainId,
		contractAddress,
		contractAddressId,
		decimals,
		readOnly: true,
		minimumWithdrawalAmount,
		minDepositAmount,
		minWithdrawalAmountInUsd,
		minDepositAmountInUsd,
	});
	const handleInput = (e: any) => {
		const { name, value } = e.target;
		setState({ ...state, [name]: value });
	};
	const filterContracts = () => {
		const x: any = contracts.filter((item: any) => {
			const sameCurrency = item.currencyId?._id === currencyId;
			const sameBlockchainNetwork =
				item.blockchainNetworkId?._id === blockchainId;
			return sameCurrency && sameBlockchainNetwork;
		});
		if (x.length > 0) {
			const d = x[0];

			setState({ ...d, ...state });
		}
	};

	const handleActionButton = () => {
		if (state.readOnly) {
			setState({ ...state, readOnly: false });
		} else {
			const data = {
				currencyId,
				blockchainNetworkId: blockchainId,
				contractAddress: state.contractAddress,
				// contractAddressId: state.contractAddressId,
				decimals: state.decimals,
				// minimumWithdrawalAmount: state.minimumWithdrawalAmount,
				// minDepositAmount: state.minDepositAmount,
				minWithdrawalAmountInUsd: Number(state.minWithdrawalAmountInUsd),
				minDepositAmountInUsd: Number(state.minDepositAmountInUsd),
				// minWithdrawalAmountInUsd: state.minWithdrawalAmountInUsd,
				// minDepositAmountInUsd: state.minDepositAmountInUsd,
			};
			dispatch(updateContractAddress(data));
			setState({ ...state, readOnly: true });
		}
	};

	const handleDisableToggle = () => {
		dispatch(
			toggleDisableWithdrawal({ currencyId, blockchainNetworkId: blockchainId })
		);
	};

	const handleDisableDepositToggle = () => {
		dispatch(
			toggleDisableDeposit({ currencyId, blockchainNetworkId: blockchainId })
		);
	};

	useEffect(() => {
		filterContracts();
	}, [state.blockchainId, contracts]);

	useEffect(() => {
		setState({ ...state, blockchainId });
	}, []);

	const checkForDisabledWithdrawal = () => {
		const record = disabledCurrencyWithdrawal.find(
			(x: any) =>
				x.isDisabled &&
				x.currencyId?._id === currencyId &&
				x.blockchainNetworkId?._id === blockchainId
		);
		return !!record;
	};

	const checkDisabledDeposit = () => {
		const record = disabledCurrencyDeposit.find(
			(x: any) =>
				x.isDisabled &&
				x.currencyId?._id === currencyId &&
				x.blockchainNetworkId?._id === blockchainId
		);
		return !!record;
	};

	const decimalOptions = [
		{ name: 'Wei (1)', value: 'wei' },
		{ name: 'Mwei (6)', value: 'mwei' },
		{ name: 'Gwei (9)', value: 'gwei' },
		{ name: 'Ether (18)', value: 'ether' },
	];

	return (
		<SingleContractAddressStyle>
			<div className="address">
				<div style={{ display: 'flex', marginBottom: 5 }}>
					<img
						alt=""
						src={blockchainIcon}
						style={{ width: 24, height: 24, marginRight: 10 }}
					/>
					<p>{blockchainAbbreviation}</p>
				</div>
				<br />
				<div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
					<div style={{ flex: 1 }}>
						<p>Min. Withdrawal Amount</p>
						{/* <Input
							name="minimumWithdrawalAmount"
							style={{ width: '100%', marginBottom: 5 }}
							size="large"
							placeholder="minimum withdrawal amount"
							value={state.minimumWithdrawalAmount}
							disabled
						/> */}
						<p style={{ fontSize: 15 }}>
							{state.minimumWithdrawalAmount
								? state.minimumWithdrawalAmount
								: 0}
						</p>
					</div>
					<div style={{ flex: 1 }}>
						<p>Min. Deposit Amount</p>
						{/* <Input
							name="minDepositAmount"
							style={{ width: '100%', marginBottom: 5 }}
							size="large"
							placeholder="Min Deposit Amount"
							value={state.minDepositAmount}
							disabled
							onChange={handleInput}
							readOnly={state.readOnly}
						/> */}
						<p style={{ fontSize: 15 }}>
							{state.minDepositAmount ? state.minDepositAmount : 0}
						</p>
					</div>
				</div>
				<br />
				<div>
					<p>Contract Address</p>

					<Input
						name="contractAddress"
						style={{ width: '100%', marginBottom: 5 }}
						size="large"
						placeholder="ContractAddress"
						value={state.contractAddress}
						onChange={handleInput}
						readOnly={state.readOnly}
					/>
				</div>
				<br />

				<div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
					<div>
						<p>Decimals (Eg: ether, mwei)</p>

						<Select
							size="large"
							value={state.decimals}
							style={{ width: '100%', marginBottom: 5 }}
							onChange={(val) => setState({ ...state, decimals: val })}
						>
							<Select.Option value="">--</Select.Option>
							{decimalOptions.map((dec) => (
								<Select.Option key={dec.value} value={dec.value}>
									{dec.name}
								</Select.Option>
							))}
						</Select>
					</div>

					<div>
						<p>Min. Withdrawal Amount In Usd</p>
						<Input
							name="minWithdrawalAmountInUsd"
							style={{ width: '100%', marginBottom: 5 }}
							size="large"
							placeholder="Min Withdrawal Amount In Usd"
							value={state.minWithdrawalAmountInUsd}
							onChange={handleInput}
							readOnly={state.readOnly}
						/>
					</div>

					<div>
						<p>Min. Deposit Amount In Usd</p>
						<Input
							name="minDepositAmountInUsd"
							style={{ width: '100%', marginBottom: 5 }}
							size="large"
							placeholder="Min Deposit Amount In Usd"
							value={state.minDepositAmountInUsd}
							onChange={handleInput}
							readOnly={state.readOnly}
						/>
					</div>
				</div>
				<br />
				<div className="grid-3-buttons">
					<div>
						<Button
							block
							type={state.readOnly ? 'default' : 'primary'}
							size="middle"
							onClick={handleActionButton}
						>
							{state.readOnly ? 'Enable Edit' : 'Update'}
						</Button>
					</div>
					<div>
						{checkDisabledDeposit() ? (
							<Button
								onClick={handleDisableDepositToggle}
								type="primary"
								size="middle"
								block
							>
								Enable Deposit
							</Button>
						) : (
							<Button
								onClick={handleDisableDepositToggle}
								block
								size="middle"
								danger
							>
								Disable Deposit for {blockchainAbbreviation}
							</Button>
						)}
					</div>
					<div>
						{checkForDisabledWithdrawal() ? (
							<Button
								onClick={handleDisableToggle}
								type="primary"
								size="middle"
								block
							>
								Enable Withdrawal
							</Button>
						) : (
							<Button onClick={handleDisableToggle} block size="middle" danger>
								Disable Withdrawal for {blockchainAbbreviation}
							</Button>
						)}
					</div>
				</div>
			</div>
			<Divider />
		</SingleContractAddressStyle>
	);
};

interface ICurrencyContractAddress {
	currencyName: string;
	currencyId: any;
}
const CurrencyContractAddresses = ({
	currencyName,
	currencyId,
}: ICurrencyContractAddress) => {
	const [visible, setVisible] = useState(false);
	const { blockchains, contracts } = useAppSelector(
		(store) => store.currencies
	);
	// const { blockchains } = useAppSelector((store) => store.currencies);
	const combinedData = blockchains.map((blockchain: any) => {
		const relatedData = contracts.find(
			(filteredItem: any) =>
				filteredItem.blockchainNetworkId?._id === blockchain._id &&
				filteredItem.currencyId?._id === currencyId
		);
		const result = relatedData || {};
		console.info('result', result);

		return { ...blockchain, result };
	});
	console.info('combinedData', combinedData);

	return (
		<div>
			<Button type="text" onClick={() => setVisible(true)}>
				Edit
			</Button>

			<Modal
				footer={null}
				title={`${currencyName} Contract Addresses`}
				open={visible}
				onCancel={() => setVisible(false)}
				width={700}
				style={{ maxWidth: '700px' }}
			>
				<p>
					You can add or edit the contract addresses for this currency / token
					by enabling edit button and clicking update.
				</p>

				<br />

				{/* {blockchains.map((item: any) => (
					<SingleContractAddress
						key={item._id}
						blockchainId={item._id}
						blockchainIcon={item.iconUrl}
						blockchainAbbreviation={item.abbreviation}
						currencyId={currencyId}
					/>
				))} */}

				{combinedData.map((item: any) => (
					<SingleContractAddress
						key={item._id}
						blockchainId={item._id}
						blockchainIcon={item.iconUrl}
						blockchainAbbreviation={item.abbreviation}
						currencyId={currencyId}
						contractAddress={item.result.contractAddress}
						contractAddressId={item.result._id}
						decimals={item.result.decimals}
						minimumWithdrawalAmount={item.result.minimumWithdrawalAmount}
						minDepositAmount={item.result.minDepositAmount}
						minWithdrawalAmountInUsd={item.result.minWithdrawalAmountInUsd}
						minDepositAmountInUsd={item.result.minDepositAmountInUsd}
					/>
				))}
			</Modal>
		</div>
	);
};

export default CurrencyContractAddresses;
